import React, { useEffect, useState } from 'react';
import api from '../services/api';

const DEFAULT_LOADER_CONFIG = Object.freeze({ enabled: true, startupHideDelayMs: 300, startupRemoveDelayMs: 680 });
let loaderConfigPromise = null;
let loaderConfigCache = null;

export function getDefaultLoaderConfig() { return DEFAULT_LOADER_CONFIG; }
export function useLoaderConfig() {
  const [config, setConfig] = useState(loaderConfigCache || DEFAULT_LOADER_CONFIG);
  useEffect(() => {
    let active = true;
    if (!loaderConfigPromise) {
      loaderConfigPromise = api.settings.getPublic({ skipAuthRefresh: true, skipAuthRedirect: true, timeout: 5000 })
        .then(response => {
          const raw = response.data?.loader || {};
          const next = {
            enabled: raw.enabled === undefined ? true : raw.enabled === true,
            startupHideDelayMs: Number.isInteger(raw.startupHideDelayMs) && raw.startupHideDelayMs >= 0 && raw.startupHideDelayMs <= 10000 ? raw.startupHideDelayMs : 300,
            startupRemoveDelayMs: Number.isInteger(raw.startupRemoveDelayMs) && raw.startupRemoveDelayMs >= 0 && raw.startupRemoveDelayMs <= 10000 ? raw.startupRemoveDelayMs : 680,
          };
          loaderConfigCache = next;
          return next;
        })
        .catch(() => { loaderConfigCache = DEFAULT_LOADER_CONFIG; return DEFAULT_LOADER_CONFIG; });
    }
    loaderConfigPromise.then(next => { if (active) setConfig(next); });
    return () => { active = false; };
  }, []);
  return config;
}

/** Shared 9jaWin loading system. */
export default function Loading({ variant = 'page', label = '', skeleton = false }) {
  const config = useLoaderConfig();
  if (!config.enabled) return null;
  if (skeleton || variant === 'skeleton') return (
    <div className="jw-skeleton-group" role="status" aria-label={label || '9jaWin loading'}>
      <span className="jw-skeleton jw-skeleton--wide" />
      <span className="jw-skeleton jw-skeleton--medium" />
      <span className="jw-skeleton jw-skeleton--short" />
    </div>
  );
  if (variant === 'section') return (
    <div className="jw-loading jw-loading--section" role="status" aria-live="polite">
      <span className="jw-loading__mark" aria-hidden="true"><i>9ja</i><b>Win</b></span>
      {label && <span className="jw-loading__label">{label}</span>}
    </div>
  );
  return (
    <div className="jw-loading jw-loading--page" role="status" aria-live="polite">
      <div className="jw-loading__content">
        <div className="jw-loading__logo" aria-label="9jaWin"><span>9ja</span><strong>Win</strong></div>
        <div className="jw-loading__track" aria-hidden="true"><span /></div>
        {label && <div className="jw-loading__label">{label}</div>}
      </div>
    </div>
  );
}
export function LoadingSkeleton({ label = '' }) { return <Loading variant="skeleton" skeleton label={label} />; }
